import _ from 'lodash';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import urls from '../urls';

/**
 * Wrapper for route to help with named routes
 */
export function route(name, options = {}) {
    const path = name ? urls.get(name).spec : null;

    let routeObj = {
        name,
        shouldRefocusRouteContent() {
            return true;
        },
        ...options
    };

    if (path) {
        routeObj.path = path;
    }

    return routeObj;
}

/**
 * Wrapper for route to allow feature flagged routes
 */
export function featureRoute(feature, ...args) {
    if (!FeatureFlagStore.get(feature)) {
        return null;
    }
    return route(...args);
}

/**
 * Wrapper for route to allow feature flagged routes
 * Allows the route if any of the supplied feature flags are enabled
 */
export function featureRouteOr(features, ...args) {
    let enabledFeatures = [];

    features.map(feature => {
        if (FeatureFlagStore.get(feature)) {
            enabledFeatures.push(feature);
        }
    });

    if (_.isEmpty(enabledFeatures)) {
        return null;
    }

    return route(...args);
}

export function featuresRoute(features, ...args) {
    return features.some(feature => !FeatureFlagStore.get(feature)) ? null : route(...args);
}

export function redirectRoute(path, to, params, query) {
    let routeObj = {
        onEnter: (nextState, replace) => {
            const { hostname, pathname } = window.location;

            if (hostname === 'localhost') {
                console.error(`*** WARNING *** No route found for '${pathname}. Check routes/index.js.`);
            }

            const currentQuery = (nextState && nextState.location && nextState.location.query) || {};
            const mergedQuery = Object.keys(currentQuery).length > 0
                ? { ...currentQuery, ...query }
                : query;

            replace(urls.location(to, params, mergedQuery));
        }
    };
    if (path) {
        routeObj.path = path;
    }
    return routeObj;
}
